import { Size, DrawerDimensions } from './types'

export const APPBAR_HEIGHT: Size = { xs: 80, sm: 80, md: 116, lg: 128 }

export const DRAWER_DIMENSIONS: DrawerDimensions = {
  width: { sm: 116, md: 192, lg: 260 },
  margin: { vertical: { sm: 34, md: 39, lg: 39 }, horizontal: { sm: 19, md: 20, lg: 20 } },
}

export const CONTENT_LAYOUT_WIDTH = 1036

export const PAGE_PADDING_SIDE: Size = { xs: 16, sm: 32, md: 48, lg: 56, xl: 96 }
export const PAGE_PADDING_TOP: Size = { xs: 16, sm: 8, md: 56, lg: 56 }

export const BOTTOM_NAVIGATION_HEIGHT = 80

export const CATEGORY_DEFAULT_OPTION = 'All available categories'
export enum SortingOptions {
  MostRecent = 'Most Recent',
  MostOrdered = 'Most Ordered',
  PriceDescending = 'Price (High to Low)',
  PriceAscending = 'Price (Low to High)',
  Alphabetical = 'Alphabetical (A-Z)',
  BestMatch = 'Best Match',
}

export const SORTING_OPTIONS = Object.values(SortingOptions).filter((v) => isNaN(Number(v)))

export const PAGINATION_DATA_LIMIT = 25

export const URLS = {
  farmlandsPRO: 'https://www.farmlandspro.co.nz',
  shopOnline: 'https://shop.farmlands.co.nz',
  findStore: 'https://farmlands.co.nz/StoreLocator',
  findOutMore: 'https://www.farmlands.co.nz/Aboutus/BecomeAShareholder/',
  termsAndConditions:
    'https://www.farmlands.co.nz/farmlands_terms_and_conditons/farmlands_apps.html',
  fulfilmentFAQs: 'https://shop.farmlands.co.nz/farmlandsprofaqs',
  signUpNow: 'https://my.1centre.com/websitebutton/78f591f9-67aa-4057-a0c9-7297ae365a4b/start',
  imageBase:
    'https://images-ap-prod.cms.commerce.dynamics.com/cms/api/qwvspcbgds/imageFileData/search?fileName=/',
}

export const CONTACT_CARD_TITLE = {
  underTabs:
    'Contact your Farmlands representative to discuss your Sales Agreements or start a new one.',
  underAgreementDetails: 'Contact your Farmlands representative to discuss this Sales Agreement.',
  noAgreements: 'Contact your Farmlands representative.',
  productDetails: 'If you have any questions please contact your Farmlands representative.',
}

export enum ScrollYPositionKeys {
  Orders = 'scrollYPositionOnOrders',
  Products = 'scrollYPositionOnProducts',
  Agreements = 'scrollYPositionOnAgreements',
}
